enum Actions {
  AuthenticationEdit = 'DASH_AUTHENTICATION_EDITED',
  EndExtensionInstall = 'DASH_EXTENSION_END_INSTALL',
  InstallExtension = 'DASH_INSTALL_EXTENSION',
  LoginError = 'DASH_LOGIN_ERROR',
  SetPresentationError = 'DASH_SET_PRESENTATION_ERROR',
  ShowPresentationSelector = 'DASH_SHOW_PRESENTATION_SELECTOR',
  StartPresenting = 'DASH_START_PRESENTING',
  StopPresenting = 'DASH_STOP_PRESENTING',
  StopUnansweredPresentation = 'DASH_STOP_UNANSWERED_PRESENTATION',
  SubmitPresenterCode = 'DASH_SUBMIT_PRESENTER_CODE',
  UpdateReady = 'UPDATE_READY',
  WaitForExtensionInstall = 'DASH_EXTENSION_WAIT_FOR_INSTALL',
  SetLoggingId = 'SET_LOGGING_ID'
}

export default Actions;



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.ts